import React from 'react';
import ContentLoader from 'react-content-loader';

const ARTIST_TITLE_AVG_HEIGHT = 40;

type Props = {
  className?: string;
};

export const UserPlaceholder: React.FC<Props> = ({ className = '' }) => (
  <div className={className}>
    <div
      className='keep-aspect-ratio keep-aspect-ratio--square'
      style={{ marginBottom: ARTIST_TITLE_AVG_HEIGHT }}
    >
      <ContentLoader
        height={350}
        width={300}
        speed={2}
        foregroundColor='#f3f3f3'
        backgroundColor='#ecebeb'
        className='keep-aspect-ratio__content'
      >
        <rect x='-1' y='-1' rx='5' ry='5' width='300' height='300' />
        <rect x='0' y='310' rx='5' ry='5' width='300' height='24' />
      </ContentLoader>
    </div>
  </div>
);
